import { __assign, __rest, __spreadArray } from "tslib";
import React from 'react';
import { VStack } from '@chakra-ui/react';
import MultipleOptionSelection from './MultipleOptionSelection';
var MultipleOptionSelectionComponent = function (_a) {
    var value = _a.value, defaultValue = _a.defaultValue, onUpdateValue = _a.onUpdateValue, items = _a.items, placeholder = _a.placeholder, props = __rest(_a, ["value", "defaultValue", "onUpdateValue", "items", "placeholder"]);
    var defaultSelected = Array.isArray(defaultValue) ? defaultValue : [];
    return (React.createElement(VStack, { w: 'full', align: 'flex-start' },
        React.createElement(MultipleOptionSelection, __assign({ onUpdate: function (payload) {
                onUpdateValue && onUpdateValue(payload);
            }, options: __spreadArray([], items, true) }, props, { value: value, defaultSelected: defaultSelected, placeholder: placeholder }))));
};
export default MultipleOptionSelectionComponent;
//# sourceMappingURL=MultipleOptionSelectionComponent.js.map